import ExtendStay from '@/components/ExtendStay'
import TripActivity from '@/components/TripActivity/TripActivity'
import TripGrouping from '@/components/TripGrouping/TripGrouping'
import useBootstrapData from '@/hooks/useBootstrapData'
import useClientSideSignedInData from '@/hooks/useClientSideSignedInData'
import useGrowthLoopAudiences from '@/hooks/useGrowthLoopAudiences'
import useTripBookings from '@/hooks/useTripBookings'

type TripDisplayOrderProps = {
  isLandingPage?: boolean
}

export default function TripDisplayOrder({ isLandingPage = false }: TripDisplayOrderProps) {
  const {
    webstats: { clientGUID },
    appName,
    appVersion,
    signInStatus: { signedIn: serverSignedIn },
    customer: { emailAddress: serverEmailAddress },
  } = useBootstrapData()

  const { signedIn: clientSideSignedIn, email: clientSideEmail } = useClientSideSignedInData()

  const signedIn = serverSignedIn || clientSideSignedIn
  const emailAddress = serverEmailAddress || clientSideEmail || ''
  const growthLoopAudiences = useGrowthLoopAudiences(emailAddress, appName, appVersion)

  const {
    extendStayBooking,
    tripGroupingBooking,
    tripGroupingAbandonedSelection,
    defaultAbandonedSelection,
  } = useTripBookings(clientGUID, appName, appVersion, emailAddress, signedIn)

  if (signedIn) {
    if (extendStayBooking) {
      return (
        <div className='flex flex-col gap-12 md:gap-8'>
          <div className='sm:max-md:hidden'>
            <ExtendStay {...extendStayBooking} />
          </div>
          <TripActivity
            // TODO: tidy up productType as part of WEB_HP_PACKAGE_SELECTIONS cleanup
            productType={['STAY', 'FLY', 'DRIVE', 'PKG']}
            pageName='homepage'
            shouldUseSmallerHeading
          />
        </div>
      )
    }

    return (
      <TripGrouping
        growthLoopAudiences={growthLoopAudiences}
        isLandingPage={isLandingPage}
        tripGroupingBooking={tripGroupingBooking}
        tripGroupingAbandonedSelection={tripGroupingAbandonedSelection}
        defaultAbandonedSelection={defaultAbandonedSelection}
      />
    )
  }

  return (
    <TripActivity
      // TODO: tidy up productType as part of WEB_HP_PACKAGE_SELECTIONS cleanup
      productType={['STAY', 'FLY', 'DRIVE', 'PKG']}
      pageName='homepage'
      shouldUseSmallerHeading={false}
    />
  )
}
